import { removeWhiteSpaces } from './removeWhiteSpaces';

export const addCountryCode = (str: string) => `${window._env_.DEFAULT_COUNTRY_CODE}${removeWhiteSpaces(str)}`;
